import template from './loanVariationDetails.html';
import controller from './loanVariationDetailsCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    loanDetails: '<',
    loanDetailScope: '<',
    lendingDetailScope: '<',
  },
};
